export const tr = {
    campaign_context_enable_cpc_hold: "Ortalama tıklama fiyatını Arama'daki ortalama tıklama fiyatının altında tut",
    campaign_context_limit: 'Harcamayı ortak kampanya harcamasının {newLimitPercent}{oldLimitPercent} oranında tut',
    campaign_context_limit_not_changed: 'Harcamayı ortak kampanya harcamasının %{limitPercent} oranında tut'
};
